import types from '../types'

const initialState = {
  /* Default values here */
  isSignedIn: false,
  isLoading: true,
  theme: 'dark',
  pagesData: {},
  onMFATab: false,
  isModelMenuShowing: false,
  selectedModel: null,
  isVerboseMode: true,
  lastRequest: null,
  canceledRequests: [],
  fillablePDFCheckCounter: 0,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case types.STORE_PAYLOAD:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
